import { render, staticRenderFns } from "./ConnectionWidget.vue?vue&type=template&id=1d7e3980&scoped=true&"
import script from "./ConnectionWidget.vue?vue&type=script&lang=js&"
export * from "./ConnectionWidget.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionWidget.vue?vue&type=style&index=0&id=1d7e3980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7e3980",
  null
  
)

export default component.exports